import React, {useState,useContext,Fragment} from "react";
import localization from "assets/localization/localization";
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import '../main.css'
import Layout from 'components/sales/layout/layout';
import SiteInformationForm from 'components/fileComplain/formSection/siteInformationForm/valetFilter';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const ZoneListing = (
    {
        getZoneList,
        zoneList = {}
    }
) => {

    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [projectId, setProjectId] = useState("");

    const headerBtns = () => {
        return (
            <Fragment>
                <a
                    href={`${baseUrl}/infra-zone`}
                    className="btn btn-primary d-none d-md-inline-block"

                >Add Zone</a>
            </Fragment>
        );
    };

    {console.log(zoneList)}
    return (

        <Layout title={localization.zone}
                Buttons={headerBtns}
                isLoading={isLoading}>
            <div className="row">
                <div className="col-md-12">
                    <PanelCardWithHeading
                        title={localization.Filter}
                        isLoading={isLoading}
                    >
                        <SiteInformationForm
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            siteInformationData={async (val) => {
                                console.log(val['projectId'])
                                setProjectId(val['projectId'])
                                setIsLoading(true);
                                await getZoneList(val['projectId']);
                                setIsLoading(false);
                            }}
                        />
                    </PanelCardWithHeading>
                </div>
                <div className="col-md-12">
                    {zoneList && zoneList.length > 0 && (
                        <PanelCardWithHeading title={localization.zoneListing}>
                            <table className="panel-table table table-bordered">
                                <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Id</th>
                                    <th>Name</th>
                                    {/*<th>Description</th>*/}
                                    <th>Active</th>
                                    <th>Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                {zoneList && zoneList.length > 0 ?
                                    <>
                                        {zoneList.map((val,key) => {

                                            return(<tr key={{key}}>
                                                <td>{key+1}</td>
                                                <td>{val.id}</td>
                                                <td>{val.name}</td>
                                                {/*<td>{val.description}</td>*/}
                                                <td>{val.active ?'Yes' :'No'}</td>
                                                <td>{val.created && val.created.slice(0,10)}</td>
                                            </tr>);
                                        })}
                                    </>
                                    : null}
                                </tbody>
                            </table>
                        </PanelCardWithHeading>
                    )}
                </div>
            </div>
        </Layout>

    );
};

export default ZoneListing
